const constants = require('@/util/constants')
require('./config')

/**
 * 获取用户设备信息
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getFingerPrint (uid, successcb, failedcb) {
    axios.get('/api/fingerprint2/get', {
        params: {
        'uid': uid,
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 备注用户信息
 * @param {*} uid
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function setNote (uid, value, successcb, failedcb) {
    axios.post('/api/fingerprint2/note', {
        uid,
        value
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
